import { environment } from "../../../environments/environment";

export function getUserFromJwtCookie(cookieName: string): string | null {
  // todo: add useFakeUserId to dev
  if (environment.useFakeUserId) {
    return environment.fakeUserId;
  }

  console.log('cookieName:', cookieName);

  console.log('splitted cookies:', document.cookie.split('; ').find(row => {
    console.log('row:', row.split('=')[0].split('.'));
    console.log('row 2:', row.split('=')[0]?.split('.').includes(cookieName));
    return row.split('=')[0]?.split('.').includes(cookieName)
  }));

  console.log('document.cookie:', document.cookie.split('; '));

  const rawCookie = document.cookie.split('; ')
    .find(row => row.split('=')[0]?.split('.').includes(cookieName)) // Check if the cookie name is part of the row
    ?.split('=')[1];

    console.log('array of cookies:', document.cookie.split('; ')
    .find(row => row.split('=')[0]?.split('.').includes(cookieName))?.split('='));

  console.log(`getUserFromJwtCookie: ${cookieName} = ${rawCookie}`);

  // return rawCookie || null;
  //note: qa doesnt allow get the cookies
  return 'eyJraWQiOiJuQzJ4MWw4TFdUNWk2RVpJOCtEK1RZb3hqZlVKWk1kVHdmbVpwQWxlbXpvPSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiJmYWU4ZDhmOS1hNGI0LTQ3ZWQtYWI3Ny04NWNjMTI3ZmU0YjAiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiaXNzIjoiaHR0cHM6XC9cL2NvZ25pdG8taWRwLnVzLWVhc3QtMS5hbWF6b25hd3MuY29tXC91cy1lYXN0LTFfQXZTU3lUQ3pmIiwiY29nbml0bzp1c2VybmFtZSI6InRlY25pY2FzY3RyIiwiZ2l2ZW5fbmFtZSI6IlByb3RlY3RhIiwiYXVkIjoiMjQwY3IyMDU0ZzZwNnBtMXUzZHNicjF1ZjQiLCJldmVudF9pZCI6ImFjZDEyMjYwLWRmZTUtNDNiMS04ZTFjLWU2NzU5Zjg2NjlmNSIsInRva2VuX3VzZSI6ImlkIiwiYXV0aF90aW1lIjoxNzQ5NDQwNTc0LCJleHAiOjE3NDk0NDQxNzQsImlhdCI6MTc0OTQ0MDU3NCwiZmFtaWx5X25hbWUiOiJTZWN1cml0eSIsImVtYWlsIjoiZGFuaWVsQGRldm1lbnRlLmNvbSJ9.HQ5Qz8ZTD_iDQ8BKK0jAAPcqAx7spxHkWcFYRYRN17cRgqo0XY6_Xw_1iphVex3OkLwo04z0LSL0lAZFtS4ZPXy9KEP2pnqzk3gjBicTSfBZKL-pEdv6jpvpV3R90xw7IuN92XteGtq_TatOg_mctXRN5dImc42itQBQH6ILqUdt4vjNjY9NfCRMqcTPXUv8UQvXKsTp52VfSp2bz36OWPruRQ8u0XHlam7NhsIh_Zj4oDE7bg6rWTs-ZwGFAKoPbbLmSKKnSLXM0TyqLME260Hrcv5ZNKHlgqVIuk3Xil6V04-s5yDevYnND0pvbhXhzNH8d_RH4-4Y54uiuH3POw';
}
